import { Descriptions, Typography, Modal, ModalProps, Spin, Flex } from "antd"
import { useExecutionDiagnosticForm } from "./queries"
import { useEventId } from ".."
import { Model } from "survey-react"

const { Text } = Typography

interface Props extends ModalProps {
  data?: string
  onClose: () => void
}

const BathroomHelpModal: React.FC<Props> = ({ data: presenceId, ...props }) => {
  const eventId = useEventId()

  const executionDiagnostic = useExecutionDiagnosticForm(
    eventId!,
    presenceId!,
    { enabled: !!presenceId && props.open }
  )
  const survey = new Model(executionDiagnostic.data?.form_definition)

  survey.data = executionDiagnostic.data?.answer_content

  const bathroomData = survey
    .getPlainData({
      includeQuestionTypes: true,
      includeValues: true,
    })
    .find((question) => question.name === "bathroom")

  return (
    <Modal
      onCancel={() => {
        props.onClose()
      }}
      footer={null}
      {...props}
    >
      {executionDiagnostic.isLoading ? (
        <Flex
          style={{
            width: "100%",
            marginTop: "var(--size-8)",
            marginBottom: "var(--size-8)",
          }}
          justify="center"
        >
          <Spin />
        </Flex>
      ) : (
        <Descriptions
          style={{ marginTop: "var(--size-5)" }}
          column={1}
          items={[
            {
              key: "bathroom",
              label: <Text strong>{bathroomData?.title}</Text>,
              children: <div>{bathroomData?.displayValue}</div>,
            },
          ]}
        />
      )}
    </Modal>
  )
}

export default BathroomHelpModal
